import { FaRegWindowRestore } from "react-icons/fa";
import { defineField, defineType, TitledListValue } from "sanity";

const subscribeToNewsletter = "subscribe_to_newsletter" as const;

const modalTypeOptions: TitledListValue<string>[] = [
  { title: "Subscribe To Newsletter", value: subscribeToNewsletter }
];

const exitIntent = "exit_intent" as const;
const timed = "timed" as const;

const modalOpeningOptions: TitledListValue<string>[] = [
  { title: "Exit Intent", value: exitIntent },
  { title: "Timed", value: timed }
];

export default defineType({
  name: "leadModal",
  title: "Lead Modal",
  type: "document",
  icon: FaRegWindowRestore,
  preview: {
    select: {
      modalContent: "modalContent",
      openingMode: "openingMode"
    },
    prepare({ modalContent, openingMode }) {
      const modalContentLabel = modalTypeOptions.find(
        (option) => option.value === modalContent
      )?.title;

      const openingModeLabel = modalOpeningOptions.find(
        (option) => option.value === openingMode
      )?.title;

      return {
        title:
          (modalContentLabel ? modalContentLabel + " | " : "") +
          openingModeLabel
      };
    }
  },
  fields: [
    defineField({
      name: "modalContent",
      title: "Modal Content",
      type: "string",
      validation: (Rule) => Rule.required(),
      options: {
        list: modalTypeOptions
      }
    }),
    defineField({
      name: "openingMode",
      title: "Opening mode",
      validation: (Rule) => Rule.required(),
      description:
        "Opening mode: Timed (after 3 seconds) or Exit Intent (when mouse exit browser window or click on homepage link)",
      type: "string",
      options: {
        list: modalOpeningOptions
      }
    })
  ]
});
